import { Provider } from './Provider';
export class SessionStorageProvider extends Provider {
    data = {};
    constructor() {
        super();
        const trackingDataString = window.sessionStorage.getItem('trackingData');
        if (!trackingDataString) {
            return this;
        }
        const trackingData = JSON.parse(trackingDataString);
        if (trackingData) {
            this.data = trackingData;
        }
    }
    get visitId() {
        return this.data.visitId || null;
    }
    get visitTimestamp() {
        const visitTimestampString = window.sessionStorage.getItem('visitTimestamp');
        if (!visitTimestampString) {
            return window.trackingHandler.viewTimestamp;
        }
        return parseInt(visitTimestampString);
    }
    get source() {
        return this.data.source || null;
    }
    get medium() {
        return this.data.medium || null;
    }
    get campaign() {
        return this.data.campaign || null;
    }
    get originDetails() {
        return this.data.originDetails || null;
    }
    get conversionPixels() {
        return this.data.conversionPixels || null;
    }
    get referralCode() {
        return this.data.referralCode || null;
    }
}
